import { styled } from 'styled-components';
import { mediumBreakpoint, smallBreakpoint } from '../../../../../common/constants';
import { useViewportWidth } from '../../../../utils/hooks/useViewportWidth';

// CS-25516: dit component moet eigenlijk het nieuwe Hero component worden, maar het Hero component moet nog gerefactored worden.
// dus voor nu is dit een tijdelijke oplossing

type HeroProps = Readonly<{
    imgUrlDesktop: string;
    imgUrlMobile: string;
}>;

export function WelcomeHero({ imgUrlDesktop, imgUrlMobile }: HeroProps) {
    const windowWidth = useViewportWidth();
    const imageUrl = windowWidth.width >= mediumBreakpoint ? imgUrlDesktop : imgUrlMobile;

    return (
        <StyledHero
            imageUrl={imageUrl}
            windowWidth={windowWidth.width}
        />
    );
}

const StyledHero = styled.div<{ imageUrl: string; windowWidth: number }>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 100%;
    min-height: ${({ windowWidth }) =>
        windowWidth >= mediumBreakpoint ? '350px' : windowWidth >= smallBreakpoint ? '250px' : '165px'};
    background: ${(props) => `url(${props.imageUrl})`};
    background-size: cover;
    background-position-y: ${({ windowWidth }) => (windowWidth >= mediumBreakpoint ? '28%' : '30%')};
`;
